"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfConversationResponseDto = instanceOfConversationResponseDto;
exports.ConversationResponseDtoFromJSON = ConversationResponseDtoFromJSON;
exports.ConversationResponseDtoFromJSONTyped = ConversationResponseDtoFromJSONTyped;
exports.ConversationResponseDtoToJSON = ConversationResponseDtoToJSON;
exports.ConversationResponseDtoToJSONTyped = ConversationResponseDtoToJSONTyped;
const ConversationMessageDto_1 = require("./ConversationMessageDto");
/**
 * Check if a given object implements the ConversationResponseDto interface.
 */
function instanceOfConversationResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('messages' in value) || value['messages'] === undefined)
        return false;
    return true;
}
function ConversationResponseDtoFromJSON(json) {
    return ConversationResponseDtoFromJSONTyped(json, false);
}
function ConversationResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'createdAt': (new Date(json['createdAt'])),
        'messages': (json['messages'].map(ConversationMessageDto_1.ConversationMessageDtoFromJSON)),
    };
}
function ConversationResponseDtoToJSON(json) {
    return ConversationResponseDtoToJSONTyped(json, false);
}
function ConversationResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'createdAt': ((value['createdAt']).toISOString()),
        'messages': (value['messages'].map(ConversationMessageDto_1.ConversationMessageDtoToJSON)),
    };
}
//# sourceMappingURL=ConversationResponseDto.js.map